import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '@/modules/core/app/helpers/store';

export class FinancialAccountSubType extends Enum {
  public key!: string;
  public value!: string;

  static CREDIT_UNKNOWN: FinancialAccountSubType = {
    key: 'credit_unknown',
    get value(): string {
      return Lang.t('financialaccount.other');
    }
  };

  static CREDIT_CREDIT_CARD: FinancialAccountSubType = {
    key: 'credit_credit_card',
    get value(): string {
      return Lang.t('financialaccount.credit-card');
    }
  };

  static CREDIT_PAYPAL: FinancialAccountSubType = {
    key: 'credit_paypal',
    get value(): string {
      return Lang.t('asset.paypal');
    }
  };

  static DEPOSITORY_UNKNOWN: FinancialAccountSubType = {
    key: 'depository_unknown',
    get value(): string {
      return Lang.t('financialaccount.other');
    }
  };

  static DEPOSITORY_CHECKING: FinancialAccountSubType = {
    key: 'depository_checking',
    get value(): string {
      return getters.auth.getCurrentEstate()?.jurisdiction.isInCanada
        ? Lang.t('asset.chequing')
        : Lang.t('asset.checking');
    }
  };

  static DEPOSITORY_CD: FinancialAccountSubType = {
    key: 'depository_cd',
    get value(): string {
      return Lang.t('financialaccount.cd');
    }
  };

  static DEPOSITORY_HSA: FinancialAccountSubType = {
    key: 'depository_hsa',
    get value(): string {
      return Lang.t('financialaccount.hsa');
    }
  };

  static DEPOSITORY_MONEY_MARKET: FinancialAccountSubType = {
    key: 'depository_money_market',
    get value(): string {
      return Lang.t('asset.money-market');
    }
  };

  static DEPOSITORY_PAYPAL: FinancialAccountSubType = {
    key: 'depository_paypal',
    get value(): string {
      return Lang.t('asset.paypal');
    }
  };

  static DEPOSITORY_SAVINGS: FinancialAccountSubType = {
    key: 'depository_savings',
    get value(): string {
      return Lang.t('asset.savings');
    }
  };

  static DEPOSITORY_PREPAID: FinancialAccountSubType = {
    key: 'depository_prepaid',
    get value(): string {
      return Lang.t('financialaccount.prepaid');
    }
  };

  static DEPOSITORY_CASH_MANAGEMENT: FinancialAccountSubType = {
    key: 'depository_cash_management',
    get value(): string {
      return Lang.t('financialaccount.cash');
    }
  };

  static DEPOSITORY_EBT: FinancialAccountSubType = {
    key: 'depository_ebt',
    get value(): string {
      return Lang.t('financialaccount.ebt');
    }
  };

  static LOAN_AUTO: FinancialAccountSubType = {
    key: 'loan_auto',
    get value(): string {
      return Lang.t('financialaccount.auto-loan');
    }
  };

  static LOAN_CONSUMER: FinancialAccountSubType = {
    key: 'loan_consumer',
    get value(): string {
      return Lang.t('financialaccount.consumer-loan');
    }
  };

  static LOAN_CONSTRUCTION: FinancialAccountSubType = {
    key: 'loan_construction',
    get value(): string {
      return Lang.t('financialaccount.construction-loan');
    }
  };

  static LOAN_HOME_EQUITY: FinancialAccountSubType = {
    key: 'loan_home_equity',
    get value(): string {
      return Lang.t('financialaccount.home-equity-loan');
    }
  };

  static LOAN_COMMERCIAL: FinancialAccountSubType = {
    key: 'loan_commercial',
    get value(): string {
      return Lang.t('financialaccount.commercial-loan');
    }
  };

  static LOAN_MORTGAGE: FinancialAccountSubType = {
    key: 'loan_mortgage',
    get value(): string {
      return Lang.t('financialaccount.mortgage-loan');
    }
  };

  static LOAN_LOAN: FinancialAccountSubType = {
    key: 'loan_loan',
    get value(): string {
      return Lang.t('financialaccount.loan');
    }
  };

  static LOAN_OVERDRAFT: FinancialAccountSubType = {
    key: 'loan_overdraft',
    get value(): string {
      return Lang.t('financialaccount.overdraft-loan');
    }
  };

  static LOAN_LINE_OF_CREDIT: FinancialAccountSubType = {
    key: 'loan_line_of_credit',
    get value(): string {
      return Lang.t('financialaccount.line-loan-credit');
    }
  };

  static LOAN_STUDENT: FinancialAccountSubType = {
    key: 'loan_student',
    get value(): string {
      return Lang.t('financialaccount.student-loan');
    }
  };

  static LOAN_RRSP: FinancialAccountSubType = {
    key: 'loan_rrsp',
    get value(): string {
      return Lang.t('financialaccount.rrsp-loan');
    }
  };

  static LOAN_OTHER: FinancialAccountSubType = {
    key: 'loan_other',
    get value(): string {
      return Lang.t('financialaccount.other-loan');
    }
  };

  static INVESTMENT_529: FinancialAccountSubType = {
    key: 'investment_529',
    get value(): string {
      return Lang.t('financialaccount.529');
    }
  };

  static INVESTMENT_403B: FinancialAccountSubType = {
    key: 'investment_403b',
    get value(): string {
      return Lang.t('financialaccount.403b');
    }
  };

  static INVESTMENT_401K: FinancialAccountSubType = {
    key: 'investment_401k',
    get value(): string {
      return Lang.t('financialaccount.401k');
    }
  };

  static INVESTMENT_457B: FinancialAccountSubType = {
    key: 'investment_457b',
    get value(): string {
      return Lang.t('financialaccount.457b');
    }
  };

  static INVESTMENT_BROKERAGE: FinancialAccountSubType = {
    key: 'investment_brokerage',
    get value(): string {
      return Lang.t('financialaccount.brokerage');
    }
  };

  static INVESTMENT_401A: FinancialAccountSubType = {
    key: 'investment_401a',
    get value(): string {
      return Lang.t('financialaccount.401a');
    }
  };

  static INVESTMENT_CASH_ISA: FinancialAccountSubType = {
    key: 'investment_cash_isa',
    get value(): string {
      return Lang.t('financialaccount.cash-isa');
    }
  };

  static INVESTMENT_EDUCATION_SAVINGS_ACCOUNT: FinancialAccountSubType = {
    key: 'investment_education_savings_account',
    get value(): string {
      return Lang.t('financialaccount.education-savings-account');
    }
  };

  static INVESTMENT_FIXED_ANNUITY: FinancialAccountSubType = {
    key: 'investment_fixed_annuity',
    get value(): string {
      return Lang.t('financialaccount.fixed-annuity');
    }
  };

  static INVESTMENT_GIC: FinancialAccountSubType = {
    key: 'investment_gic',
    get value(): string {
      return Lang.t('financialaccount.gic');
    }
  };

  static INVESTMENT_HEALTH_REIMBURSEMENT_ARRANGEMENT: FinancialAccountSubType = {
    key: 'investment_health_reimbursement_arrangement',
    get value(): string {
      return Lang.t('financialaccount.health-reimbursement-arrangement');
    }
  };

  static INVESTMENT_HSA: FinancialAccountSubType = {
    key: 'investment_hsa',
    get value(): string {
      return Lang.t('asset.hsa');
    }
  };

  static INVESTMENT_IRA: FinancialAccountSubType = {
    key: 'investment_ira',
    get value(): string {
      return Lang.t('financialaccount.ira');
    }
  };

  static INVESTMENT_ISA: FinancialAccountSubType = {
    key: 'investment_isa',
    get value(): string {
      return Lang.t('financialaccount.isa');
    }
  };

  static INVESTMENT_KEOGH: FinancialAccountSubType = {
    key: 'investment_keogh',
    get value(): string {
      return Lang.t('financialaccount.keogh');
    }
  };

  static INVESTMENT_LIF: FinancialAccountSubType = {
    key: 'investment_lif',
    get value(): string {
      return Lang.t('financialaccount.lif');
    }
  };

  static INVESTMENT_LIRA: FinancialAccountSubType = {
    key: 'investment_lira',
    get value(): string {
      return Lang.t('financialaccount.lira');
    }
  };

  static INVESTMENT_LRIF: FinancialAccountSubType = {
    key: 'investment_lrif',
    get value(): string {
      return Lang.t('financialaccount.lrif');
    }
  };

  static INVESTMENT_LRSP: FinancialAccountSubType = {
    key: 'investment_lrsp',
    get value(): string {
      return Lang.t('financialaccount.lrsp');
    }
  };

  static INVESTMENT_MUTUAL_FUND: FinancialAccountSubType = {
    key: 'investment_mutual_fund',
    get value(): string {
      return Lang.t('financialaccount.mutual-fund');
    }
  };

  static INVESTMENT_PENSION: FinancialAccountSubType = {
    key: 'investment_pension',
    get value(): string {
      return Lang.t('financialaccount.pension');
    }
  };

  static INVESTMENT_PRIF: FinancialAccountSubType = {
    key: 'investment_prif',
    get value(): string {
      return Lang.t('financialaccount.prif');
    }
  };

  static INVESTMENT_PROFIT_SHARING_PLAN: FinancialAccountSubType = {
    key: 'investment_profit_sharing_plan',
    get value(): string {
      return Lang.t('financialaccount.profit-sharing-plan');
    }
  };

  static INVESTMENT_NON_TAXABLE_BROKERAGE_ACCOUNT: FinancialAccountSubType = {
    key: 'investment_non_taxable_brokerage_account',
    get value(): string {
      return Lang.t('financialaccount.non-taxable-account');
    }
  };

  static INVESTMENT_QSHR: FinancialAccountSubType = {
    key: 'investment_qshr',
    get value(): string {
      return Lang.t('financialaccount.qshr');
    }
  };

  static INVESTMENT_RDSP: FinancialAccountSubType = {
    key: 'investment_rdsp',
    get value(): string {
      return Lang.t('financialaccount.rdsp');
    }
  };

  static INVESTMENT_RESP: FinancialAccountSubType = {
    key: 'investment_resp',
    get value(): string {
      return Lang.t('financialaccount.resp');
    }
  };

  static INVESTMENT_RETIREMENT: FinancialAccountSubType = {
    key: 'investment_retirement',
    get value(): string {
      return Lang.t('financialaccount.retirement');
    }
  };

  static INVESTMENT_RLIF: FinancialAccountSubType = {
    key: 'investment_rlif',
    get value(): string {
      return Lang.t('financialaccount.rlif');
    }
  };

  static INVESTMENT_ROTH: FinancialAccountSubType = {
    key: 'investment_roth',
    get value(): string {
      return Lang.t('financialaccount.roth');
    }
  };

  static INVESTMENT_ROTH_401K: FinancialAccountSubType = {
    key: 'investment_roth_401k',
    get value(): string {
      return Lang.t('financialaccount.roth-401k');
    }
  };

  static INVESTMENT_RRIF: FinancialAccountSubType = {
    key: 'investment_rrif',
    get value(): string {
      return Lang.t('financialaccount.rrif');
    }
  };

  static INVESTMENT_RRSP: FinancialAccountSubType = {
    key: 'investment_rrsp',
    get value(): string {
      return Lang.t('financialaccount.rrsp');
    }
  };

  static INVESTMENT_SARSEP: FinancialAccountSubType = {
    key: 'investment_sarsep',
    get value(): string {
      return Lang.t('financialaccount.sarsep');
    }
  };

  static INVESTMENT_SEP_IRA: FinancialAccountSubType = {
    key: 'investment_sep_ira',
    get value(): string {
      return Lang.t('financialaccount.sep-ira');
    }
  };

  static INVESTMENT_SIMPLE_IRA: FinancialAccountSubType = {
    key: 'investment_simple_ira',
    get value(): string {
      return Lang.t('financialaccount.simple-ira');
    }
  };

  static INVESTMENT_SIPP: FinancialAccountSubType = {
    key: 'investment_sipp',
    get value(): string {
      return Lang.t('financialaccount.sipp');
    }
  };

  static INVESTMENT_STOCK_PLAN: FinancialAccountSubType = {
    key: 'investment_stock_plan',
    get value(): string {
      return Lang.t('financialaccount.stock-plan');
    }
  };

  static INVESTMENT_TFSA: FinancialAccountSubType = {
    key: 'investment_tfsa',
    get value(): string {
      return Lang.t('financialaccount.tfsa');
    }
  };

  static INVESTMENT_TRUST: FinancialAccountSubType = {
    key: 'investment_trust',
    get value(): string {
      return Lang.t('financialaccount.trust');
    }
  };

  static INVESTMENT_UGMA: FinancialAccountSubType = {
    key: 'investment_ugma',
    get value(): string {
      return Lang.t('financialaccount.ugma');
    }
  };

  static INVESTMENT_VARIABLE: FinancialAccountSubType = {
    key: 'investment_variable',
    get value(): string {
      return Lang.t('financialaccount.variable');
    }
  };

  static INVESTMENT_UTMA: FinancialAccountSubType = {
    key: 'investment_utma',
    get value(): string {
      return Lang.t('financialaccount.utma');
    }
  };

  static INVESTMENT_VARIABLE_ANNUITY: FinancialAccountSubType = {
    key: 'investment_variable_annuity',
    get value(): string {
      return Lang.t('financialaccount.variable-annuity');
    }
  };

  static INVESTMENT_CASH: FinancialAccountSubType = {
    key: 'investment_cash',
    get value(): string {
      return Lang.t('financialaccount.investment-cash');
    }
  };

  static INVESTMENT_CHEQUING: FinancialAccountSubType = {
    key: 'investment_chequing',
    get value(): string {
      return Lang.t('financialaccount.investment-chequing');
    }
  };

  static INVESTMENT_MARGIN: FinancialAccountSubType = {
    key: 'investment_margin',
    get value(): string {
      return Lang.t('financialaccount.investment-margin');
    }
  };

  static INVESTMENT_SHORT: FinancialAccountSubType = {
    key: 'investment_short',
    get value(): string {
      return Lang.t('financialaccount.short');
    }
  };

  static INVESTMENT_LONG: FinancialAccountSubType = {
    key: 'investment_long',
    get value(): string {
      return Lang.t('financialaccount.long');
    }
  };

  static INVESTMENT_RPP: FinancialAccountSubType = {
    key: 'investment_rpp',
    get value(): string {
      return Lang.t('financialaccount.registered-pension-plan');
    }
  };

  static INVESTMENT_RLSP: FinancialAccountSubType = {
    key: 'investment_rlsp',
    get value(): string {
      return Lang.t('financialaccount.restricted-locked-savings');
    }
  };

  static INVESTMENT_IPP: FinancialAccountSubType = {
    key: 'investment_ipp',
    get value(): string {
      return Lang.t('financialaccount.investment-ipp');
    }
  };

  static INVESTMENT_DPSP: FinancialAccountSubType = {
    key: 'investment_dpsp',
    get value(): string {
      return Lang.t('financialaccount.deferred-profit-plan');
    }
  };

  static INVESTMENT_SPP: FinancialAccountSubType = {
    key: 'investment_spp',
    get value(): string {
      return Lang.t('financialaccount.spp');
    }
  };

  static INVESTMENT_NDCP: FinancialAccountSubType = {
    key: 'investment_ndcp',
    get value(): string {
      return Lang.t('financialaccount.ndcp');
    }
  };

  static INVESTMENT_NRSP: FinancialAccountSubType = {
    key: 'investment_nrsp',
    get value(): string {
      return Lang.t('financialaccount.non-savings-plan');
    }
  };

  static INVESTMENT_EPSP: FinancialAccountSubType = {
    key: 'investment_epsp',
    get value(): string {
      return Lang.t('financialaccount.employee-profit-plan');
    }
  };

  static INVESTMENT_ESPP: FinancialAccountSubType = {
    key: 'investment_espp',
    get value(): string {
      return Lang.t('financialaccount.employee-stock-purchase');
    }
  };

  static INVESTMENT_ESOP: FinancialAccountSubType = {
    key: 'investment_esop',
    get value(): string {
      return Lang.t('financialaccount.employee-stock-plan');
    }
  };

  static INVESTMENT_VRSP: FinancialAccountSubType = {
    key: 'investment_vrsp',
    get value(): string {
      return Lang.t('financialaccount.voluntary-savings-plan');
    }
  };

  static INVESTMENT_FHSA: FinancialAccountSubType = {
    key: 'investment_fhsa',
    get value(): string {
      return Lang.t('financialaccount.first-savings-account');
    }
  };

  static INVESTMENT_UNKNOWN: FinancialAccountSubType = {
    key: 'investment_unknown',
    get value(): string {
      return Lang.t('financialaccount.other-investment');
    }
  };

  static INVESTMENT_SEGREGATED_FUNDS: FinancialAccountSubType = {
    key: 'investment_segregated_funds',
    get value(): string {
      return Lang.t('financialaccount.segregated-funds');
    }
  };

  static getRegisteredInvestmentSubTypes(): string[] {
    return [
      FinancialAccountSubType.INVESTMENT_403B.key,
      FinancialAccountSubType.INVESTMENT_401K.key,
      FinancialAccountSubType.INVESTMENT_457B.key,
      FinancialAccountSubType.INVESTMENT_401A.key,
      FinancialAccountSubType.INVESTMENT_CASH_ISA.key,
      FinancialAccountSubType.INVESTMENT_EDUCATION_SAVINGS_ACCOUNT.key,
      FinancialAccountSubType.INVESTMENT_IRA.key,
      FinancialAccountSubType.INVESTMENT_LIF.key,
      FinancialAccountSubType.INVESTMENT_LIRA.key,
      FinancialAccountSubType.INVESTMENT_LRIF.key,
      FinancialAccountSubType.INVESTMENT_LRSP.key,
      FinancialAccountSubType.INVESTMENT_PENSION.key,
      FinancialAccountSubType.INVESTMENT_PRIF.key,
      FinancialAccountSubType.INVESTMENT_NON_TAXABLE_BROKERAGE_ACCOUNT.key,
      FinancialAccountSubType.INVESTMENT_RDSP.key,
      FinancialAccountSubType.INVESTMENT_RESP.key,
      FinancialAccountSubType.INVESTMENT_RETIREMENT.key,
      FinancialAccountSubType.INVESTMENT_RLIF.key,
      FinancialAccountSubType.INVESTMENT_ROTH_401K.key,
      FinancialAccountSubType.INVESTMENT_ROTH.key,
      FinancialAccountSubType.INVESTMENT_RRIF.key,
      FinancialAccountSubType.INVESTMENT_RRSP.key,
      FinancialAccountSubType.INVESTMENT_SARSEP.key,
      FinancialAccountSubType.INVESTMENT_SEP_IRA.key,
      FinancialAccountSubType.INVESTMENT_SIMPLE_IRA.key,
      FinancialAccountSubType.INVESTMENT_TFSA.key,
      FinancialAccountSubType.INVESTMENT_TRUST.key,
      FinancialAccountSubType.INVESTMENT_SEGREGATED_FUNDS.key
    ];
  }

  static getIsTaxApplicableSubType(): string[] {
    return [
      FinancialAccountSubType.INVESTMENT_FIXED_ANNUITY.key,
      FinancialAccountSubType.INVESTMENT_MUTUAL_FUND.key,
      FinancialAccountSubType.INVESTMENT_STOCK_PLAN.key,
      FinancialAccountSubType.INVESTMENT_VARIABLE_ANNUITY.key,
      FinancialAccountSubType.INVESTMENT_VARIABLE.key,
      FinancialAccountSubType.INVESTMENT_GIC.key,
      FinancialAccountSubType.DEPOSITORY_CD.key,
      FinancialAccountSubType.INVESTMENT_BROKERAGE.key,
      FinancialAccountSubType.INVESTMENT_SEGREGATED_FUNDS.key
    ];
  }

  static getSubTypesWithStockHolding(): string[] {
    return [
      FinancialAccountSubType.DEPOSITORY_MONEY_MARKET.key,
      FinancialAccountSubType.INVESTMENT_401A.key,
      FinancialAccountSubType.INVESTMENT_401K.key,
      FinancialAccountSubType.INVESTMENT_403B.key,
      FinancialAccountSubType.INVESTMENT_457B.key,
      FinancialAccountSubType.INVESTMENT_BROKERAGE.key,
      FinancialAccountSubType.INVESTMENT_CASH_ISA.key,
      FinancialAccountSubType.INVESTMENT_CASH_ISA.key,
      FinancialAccountSubType.INVESTMENT_EDUCATION_SAVINGS_ACCOUNT.key,
      FinancialAccountSubType.INVESTMENT_IRA.key,
      FinancialAccountSubType.INVESTMENT_ISA.key,
      FinancialAccountSubType.INVESTMENT_LIF.key,
      FinancialAccountSubType.INVESTMENT_LIRA.key,
      FinancialAccountSubType.INVESTMENT_LRIF.key,
      FinancialAccountSubType.INVESTMENT_LRSP.key,
      FinancialAccountSubType.INVESTMENT_MUTUAL_FUND.key,
      FinancialAccountSubType.INVESTMENT_NON_TAXABLE_BROKERAGE_ACCOUNT.key,
      FinancialAccountSubType.INVESTMENT_PENSION.key,
      FinancialAccountSubType.INVESTMENT_PROFIT_SHARING_PLAN.key,
      FinancialAccountSubType.INVESTMENT_ROTH.key,
      FinancialAccountSubType.INVESTMENT_ROTH_401K.key,
      FinancialAccountSubType.INVESTMENT_SEP_IRA.key,
      FinancialAccountSubType.INVESTMENT_SIMPLE_IRA.key,
      FinancialAccountSubType.INVESTMENT_STOCK_PLAN.key
    ];
  }
}
